<template>
  <div class="maintain">
    <ListTitle :title="title" :titleImg="titleImg" />
    <ListGroup :itemList="itemList" :fn="goToDetails" />
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/layouts/footer.vue";
import ListTitle from "@/components/ui/searchList/ListTitle.vue";
import ListGroup from "@/components/ui/searchList/ListGroup.vue";
export default {
  props: {
    title: {
      type: String,
      default: "養護專區"
    },
    titleImg: {
      type: String,
      default: "common/icon_maintain.svg"
    }
  },
  data() {
    return {
      itemList: []
    };
  },
  components: {
    Footer,
    ListTitle,
    ListGroup
  },

  methods: {
    goToDetails(item, idx) {
      this.SYS.goToDetails(
        item,
        idx,
        this.itemList,
        "MainTain-Detail"
        //this.$router
      );
    }
  },
  mounted() {
    this.itemList = [];
    this.itemList = this.$store.state.announce.mainTainList;
    if (this.itemList.length == 0) {
      this.$store.dispatch("setProcessWait", [
        this.$store.dispatch("getMainTainList").then(() => {
          this.itemList = this.$store.state.announce.mainTainList;
        })
      ]);
    }
  }
};
</script>
<style lang="scss" scoped>
.maintain {
  height: inherit;
  background-color: #f6edd9;
}
</style>
